<template>
    <el-dialog
        v-if="isDialogVisible"
        :visible="true"
        @close="onFormClose"
        :title="title"
    >
        <loading v-if="isFormBusy"></loading>
        <quick-form
            v-show="!isFormBusy"
            :get-form-url="getFormUrl"
            :initial-model="model"
            @initialized="this.onFormInitialized"
            @initialization-error="this.onFormInitializationError"
            @created="onCreated"
            @updated="onUpdated"
            :mode="mode"
        ></quick-form>
    </el-dialog>
</template>

<script>
  import eventBus from "../../event-bus";
  import QuickForm from "./quick-form";
  import Loading from "../loading";
  import {modes} from "../send-list/types";


  export default {
    components: {
      QuickForm,
      Loading,
    },

    data() {
      return {
        getFormUrl: null,
        model: {},
        isFormBusy: true,
        title: null,
        mode: null,
      };
    },

    computed: {
      isDialogVisible() {
        return !_.isNull(this.getFormUrl);
      }
    },

    methods: {
      /**
       * @param {*} payload
       */
      showForm({mode, title, url, model}) {
        this.getFormUrl = url;
        this.model = model;
        this.title = title || 'FORM';
        this.mode = mode || modes.normal;
      },

      /**
       * @return {undefined}
       */
      onFormClose() {
        this.destroyForm();
      },

      /**
       * @return {undefined}
       */
      onFormInitialized() {
        this.isFormBusy = false;
      },

      /**
       * @return {undefined}
       */
      destroyForm() {
        this.isFormBusy = true;
        this.getFormUrl = null;
      },

      /**
       * @param {Object} value
       */
      onFormInitializationError({message}) {
        this.destroyForm();
        message && this.$message.error(message);
      },

      /**
       * @param {Object} value
       */
      onCreated({model, message}) {
        this.destroyForm();
        message && this.$message.success(message);
        eventBus.$emit('send-list-created', {model});
      },

      /**
       * @param {Object} value
       */
      onUpdated({model, message}) {
        this.destroyForm();
        message && this.$message.success(message);
        eventBus.$emit('send-list-updated', {model});
      },
    },

    created() {
      eventBus.$on('show-send-list-modal-form', this.showForm);
    },

    beforeDestroy() {
      eventBus.$off('show-send-list-modal-form', this.showForm);
    },
  }
</script>

